<svg
	class="cursor-pointer"
	width="16"
	height="16"
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 25.56 25.56"
	><g data-name="Layer 2"
		><g data-name="Layer 1"
			><circle cx="12.78" cy="12.78" r="12.28" style="fill:none;stroke:#79f8fb" /><path
				d="m17.89 12.08-6.22 6.22-.9-.91.09-.09H9.63a.43.43 0 0 1-.43-.43v-1.23l-.09.09a1.08 1.08 0 0 0-.27.46l-.61 2.09 2.08-.62a1.21 1.21 0 0 0 .46-.27l.9.91a2.42 2.42 0 0 1-1 .59l-3.21.94a.65.65 0 0 1-.79-.83l.94-3.21a2.34 2.34 0 0 1 .6-1l6.22-6.22Zm1.9-4.31a1.7 1.7 0 0 1 0 2.41l-1.29 1.3L15 8l1.29-1.29a1.71 1.71 0 0 1 2.42 0Z"
				style="fill:#79f8fb"
			/></g
		></g
	></svg
>
